import Vue from "vue";

// axios
import axios from "axios";
import jwtDefaultConfig from "@/@core/auth/jwt/jwtDefaultConfig";

const axiosIns = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || "http://127.0.0.1:8001/api/",
  timeout: 90000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// Request interceptor — inject Bearer token from sessionStorage
axiosIns.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem(jwtDefaultConfig.storageTokenKeyName);
    if (token) {
      config.headers.Authorization = `${jwtDefaultConfig.tokenType} ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor — handle 401 by clearing session and redirecting to login
axiosIns.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      try {
        const dbg = JSON.parse(sessionStorage.getItem("__debug401") || "[]");
        dbg.push({
          source: "libs/axios.js",
          url: error.config?.baseURL + error.config?.url,
          method: error.config?.method,
          status: error.response.status,
          body: JSON.stringify(error.response?.data).slice(0, 300),
          time: new Date().toISOString(),
        });
        sessionStorage.setItem("__debug401", JSON.stringify(dbg));
      } catch (_) {}
      sessionStorage.removeItem(jwtDefaultConfig.storageTokenKeyName);
      sessionStorage.removeItem(jwtDefaultConfig.storageRefreshTokenKeyName);
      // Clear userData from both storages (app stores it in sessionStorage, legacy used localStorage)
      sessionStorage.removeItem("userData");
      localStorage.removeItem("userData");
      localStorage.removeItem("user-role");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

Vue.prototype.$http = axiosIns;

export default axiosIns;
